export default "__VITE_ASSET__46d19083__"